import { useEffect } from 'react';

import { useAppDispatch } from 'shared/lib/redux';
import { StreamCard } from 'shared/ui/stream-card';
import { generateCardEventHandlers } from 'shared/api/event-service';
import { StreamPreviewLayout } from 'widgets/stream-preview/ui/stream-preview-layout';
import {
  useWalkthroughAssignments,
  WALKTHROUGH_CONFIGS,
} from 'features/walkthrough';
// eslint-disable-next-line boundaries/element-types
import { useUserProgramsData } from 'widgets/programs/model';
// eslint-disable-next-line no-restricted-imports
import { WalkthroughType } from 'features/walkthrough/types';
// eslint-disable-next-line no-restricted-imports
import { setWalkthroughConfig } from 'features/walkthrough/model/walkthrough-slice';

export const WalkthroughStreamContent = () => {
  const { walkthroughAssignments: allWalkthroughAssignments } =
    useWalkthroughAssignments();
  const { userProgramsData } = useUserProgramsData();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!allWalkthroughAssignments) return;

    const hasAssignments = allWalkthroughAssignments.length > 0;
    const hasPrograms = userProgramsData.length > 0;

    if (hasAssignments) {
      if (hasPrograms) {
        dispatch(
          setWalkthroughConfig(WALKTHROUGH_CONFIGS[WalkthroughType.FULL]),
        );
      } else {
        dispatch(
          setWalkthroughConfig(
            WALKTHROUGH_CONFIGS[WalkthroughType.FULL_NO_PROGRAMS],
          ),
        );
      }
    } else {
      if (hasPrograms) {
        dispatch(
          setWalkthroughConfig(WALKTHROUGH_CONFIGS[WalkthroughType.SHORT]),
        );
      } else {
        dispatch(
          setWalkthroughConfig(
            WALKTHROUGH_CONFIGS[WalkthroughType.SHORT_NO_PROGRAMS],
          ),
        );
      }
    }
  }, [userProgramsData, allWalkthroughAssignments, dispatch]);

  if (!allWalkthroughAssignments?.length) return null;

  const previewWalkthroughAssignments = allWalkthroughAssignments.slice(0, 4);

  return (
    <StreamPreviewLayout showSeeAllButton>
      {previewWalkthroughAssignments.map((assignment) => {
        return (
          <StreamCard
            key={assignment.businessKey}
            classLabel="Class A"
            content={assignment.content}
            caption="You assigned"
            eventHandlers={generateCardEventHandlers({
              currentClassGrades: ['05', '06'],
              item: assignment,
            })}
            readyThumbnailUrl={assignment.content.lessonThumbnailImagePath}
            isWalkthroughActive
            dueDate={assignment.dueDate}
            startDate={assignment.startDate}
            readyLessonNumber="Lesson 1"
            readyLinkToLesson="fake-link-to-lesson"
            viewWorkButtonUrl="fake-view-work-button-url"
            assignment={assignment}
          />
        );
      })}
    </StreamPreviewLayout>
  );
};
